import { ComponentPropsWithoutRef } from "react";
import { BlockQuote as IBlockQuote } from "~/sanity/types";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionBlockQuote.css";
import { BlockQuote } from "~/components/elements/BlockQuote";

export type SectionBlockQuoteProps = ComponentPropsWithoutRef<"div"> & {
  data: IBlockQuote;
};

export const SectionBlockQuote = ({
  data,
  ...props
}: SectionBlockQuoteProps) => {
  return (
    <section>
      <Grid className={styles.wrapper} {...props}>
        <div className={styles.quote}>{data && <BlockQuote data={data} />}</div>
      </Grid>
    </section>
  );
};
